// 輪詢相關翻譯

export const polling = {
    // Error messages
    queryStatusFailed: '查詢狀態失敗，請稍後重試',
    taskNotFound: '任務未找到，可能已被刪除',
    authenticationFailed: '身份驗證失敗，請重新登錄',
    serverInternalError: '服務器內部錯誤，請稍後重試',
    requestTooFrequent: '請求過於頻繁，請稍後重試',
    networkConnectionFailed: '網絡連接失敗，請檢查網絡連接',
    unknownError: '未知錯誤',
    generationFailed: '生成失敗',
    
    // Status messages
    generationTimeout: '生成超時，請重試',
    
    // Error types
    contentPolicy: '內容不符合平台政策，請修改後重試',
    recitationConcern: '內容可能涉及版權問題，請修改提示詞後重試',
    rateLimit: '請求過於頻繁，請稍後重試',
    credits: '積分不足，請充值後重試',
    timeout: '生成超時，請重試',
    noImageGenerated: '無法為此提示詞生成圖片，請嘗試修改提示詞',
    
    // Toast messages
    generationFailedToast: '生成失敗'
  };
